import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import { Controller, useFormContext } from 'react-hook-form';
import { useLoadLightUsers } from 'shared/hooks/use-load-light-users';
import { CustomSelect } from 'shared/io';

import styleIdentifiers from './TaskForm.module.scss';

const styles = classNames.bind(styleIdentifiers);

type TaskFormAdditionalAssigneesProps = {
  name?: 'additional_assignee_ids' | 'task_attributes.additional_assignee_ids';
  primaryUserFieldName?: 'user_id' | 'task_attributes.user_id';
  disabled?: boolean;
};

export const TaskFormAdditionalAssignees = ({
  name = 'additional_assignee_ids',
  primaryUserFieldName = 'user_id',
  disabled = false,
}: TaskFormAdditionalAssigneesProps) => {
  const { t } = useTranslation();
  const { users = [] } = useLoadLightUsers();
  const { watch } = useFormContext();

  const primaryUserId = watch(primaryUserFieldName);

  const items = users
    .filter(user => user.id.toString() !== primaryUserId)
    .map(user => ({ id: user.id, name: user.name.full }));

  return (
    <Controller
      name={name}
      render={() => (
        <CustomSelect
          selectClassName={styles('input')}
          keyText="name"
          keyValue="id"
          multiple
          filter
          withBorder
          name={name}
          label={t(i18nKeys.TASK.ATTRIBUTES.ADDITIONAL_ASSIGNEES)}
          placeholder={t(i18nKeys.TASK.ATTRIBUTES.ADDITIONAL_ASSIGNEES_PLACEHOLDER)}
          items={items}
          notAllowed={disabled}
        />
      )}
    />
  );
};
